import { render, staticRenderFns } from "./UpdateBootloader.vue?vue&type=template&id=c0b1d5c4"
import script from "./UpdateBootloader.vue?vue&type=script&lang=js"
export * from "./UpdateBootloader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports